// Angular + external
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FlexLayoutModule } from "@angular/flex-layout";
import { RouterModule } from "@angular/router";
/**********************************************************/
// BFX
// Components
import { BfxTimerComponent } from "./bfx-timer.component";
import { BfxGoldenLayoutPlaceholderComponent } from "./bfx-golden-layout-placeholder.component";
import { BfxBaseBlotterColumnSelector } from "../bfx-base-blotter/bfx-base-blotter-columnselector";
import { BfxAutoFocus } from "../shared/directives/BfxAutoFocus";
import { BfxElementOnBody } from "../shared/directives/BfxElementOnBody";
import { BfxInputLabelOnClick } from "../shared/directives/bfx-input-label-onclick";
import { BfxPatchDragAutoclose } from "../shared/directives/patch-drag-autoclose.directive";
import { BfxPatchPCalendarIcon } from "../shared/directives/patch-p-calendar-icon";
import { BfxPatchDatePickerOnOpen } from "../shared/directives/patch-date-picker-on-open.directive";
import { BfxModelChangeSubjectDirective } from "../shared/directives/BfxModelChangeSubjectDirective";
import { BfxModelTouchedSubjectDirective } from "../shared/directives/BfxModelTouchedSubjectDirective";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { NumberSpinnerComponent } from "shared/base-components/number-spinner.component";
import { SpinnerButtonsComponent } from "shared/base-components/spinner-buttons.component";
import { RateSpinnerComponent } from "shared/base-components/rate-spinner.component";
import { AmountSpinnerComponent } from "shared/base-components/amount-spinner.component";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";

@NgModule({
  declarations: [
    BfxTimerComponent,
    BfxGoldenLayoutPlaceholderComponent,
    BfxAutoFocus,
    BfxElementOnBody,
    BfxModelChangeSubjectDirective,
    BfxModelTouchedSubjectDirective,
    BfxBaseBlotterColumnSelector,
    BfxPatchDragAutoclose,
    BfxPatchDatePickerOnOpen,
    BfxPatchPCalendarIcon,
    BfxInputLabelOnClick,
  ],
  exports: [
    BfxTimerComponent,
    BfxGoldenLayoutPlaceholderComponent,
    BfxAutoFocus,
    BfxElementOnBody,
    BfxModelChangeSubjectDirective,
    BfxModelTouchedSubjectDirective,
    BfxBaseBlotterColumnSelector,
    BfxInputLabelOnClick,
    BfxPatchDragAutoclose,
    BfxPatchDatePickerOnOpen,
    BfxPatchPCalendarIcon,
    RateSpinnerComponent,
    AmountSpinnerComponent,
    NumberSpinnerComponent,
    SpinnerButtonsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    BaseComponentsModule,
    BfxElementsLibraryModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class BfxSharedModule {}
